import { render, staticRenderFns } from "./PublicAnnouncements.vue?vue&type=template&id=b166e7cc&scoped=true&"
import script from "./PublicAnnouncements.vue?vue&type=script&lang=js&"
export * from "./PublicAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b166e7cc",
  null
  
)

export default component.exports